import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "./apiClient";

const withAuthHeaders = (getState) => {
  const { auth } = getState();
  const token = auth?.access_token;
  const tokenType = auth?.token_type || "Bearer";
  return { Authorization: `${tokenType} ${token}` };
};

export const fetchFeatures = createAsyncThunk(
  "productData/fetchFeatures",
  async (productCode, { getState, rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/products/${productCode}/features`, {
        headers: withAuthHeaders(getState),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: error.message });
    }
  }
);

export const fetchPlans = createAsyncThunk(
  "productData/fetchPlans",
  async (productCode, { getState, rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/products/${productCode}/plans-with-features`, {
        headers: withAuthHeaders(getState),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: error.message });
    }
  }
);

export const fetchStatistics = createAsyncThunk(
  "productData/fetchStatistics",
  async (productCode, { getState, rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/products/${productCode}/statistics`, {
        headers: withAuthHeaders(getState),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: error.message });
    }
  }
);

export const fetchTestimonials = createAsyncThunk(
  "productData/fetchTestimonials",
  async (productCode, { getState, rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/products/${productCode}/testimonials`, {
        headers: withAuthHeaders(getState),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: error.message });
    }
  }
);

export const fetchSteps = createAsyncThunk(
  "productData/fetchSteps",
  async (productCode, { getState, rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/products/${productCode}/steps`, {
        headers: withAuthHeaders(getState),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: error.message });
    }
  }
);

export const fetchFaqs = createAsyncThunk(
  "productData/fetchFaqs",
  async (productCode, { getState, rejectWithValue }) => {
    try {
      const response = await apiClient.get(`/products/${productCode}/faqs`, {
        headers: withAuthHeaders(getState),
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || { message: error.message });
    }
  }
);

const initialState = {
  features: { data: [], status: "idle", error: null },
  plans: { data: [], status: "idle", error: null },
  statistics: { data: [], status: "idle", error: null },
  testimonials: { data: [], status: "idle", error: null },
  steps: { data: [], status: "idle", error: null },
  faqs: { data: [], status: "idle", error: null },
};

const productDataSlice = createSlice({
  name: "productData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    const register = (thunk, key) => {
      builder
        .addCase(thunk.pending, (state) => {
          state[key].status = "loading";
          state[key].error = null;
        })
        .addCase(thunk.fulfilled, (state, action) => {
          state[key].status = "succeeded";
          state[key].data = Array.isArray(action.payload)
            ? action.payload
            : action.payload?.data || [];
        })
        .addCase(thunk.rejected, (state, action) => {
          state[key].status = "failed";
          state[key].error = action.payload || action.error?.message || "Request failed";
        });
    };

    register(fetchFeatures, "features");
    register(fetchPlans, "plans");
    register(fetchStatistics, "statistics");
    register(fetchTestimonials, "testimonials");
    register(fetchSteps, "steps");
    register(fetchFaqs, "faqs");
  },
});

export default productDataSlice.reducer;



